export default {
    filters: {
      path: function(_path) {
        const prefix = CDN_URL ? `${CDN_URL}/` : '/';
        return `${prefix}${_path}`;
      }
    }
  }